import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=0497cd9c&scoped=true&"
import script from "./ItemGroup.vue?vue&type=script&lang=ts&"
export * from "./ItemGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497cd9c",
  null
  
)

export default component.exports